import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import * as $ from "jquery";
function ExplorerFilterTypeString(parent) {
    var self = this;
    self.ObjectValue = ko.observable();
    self.ExplorerFilterOperatorId = ko.observable();
    self.Caption = ko.observable();
    self.TextEnabled = ko.observable(true);
    self.Focus = function () { };
    self.Save = function () {
        return Bao.post("ExplorerFilter/SaveExplorerFilterDefinitionString", JSON.stringify({
            objectValue: self.ObjectValue(),
            explorerFilterOperatorId: self.ExplorerFilterOperatorId(),
            explorerFilterDefinitionId: parent.SelectedExplorerFilterDefinitionId(),
            sessionTabId: parent.TabPage.SessionTabId
        }), function (result) { });
    };
    self.loaded = function () {
        if (parent != null && parent.ExplorerFilterDefinitionDataSource() != null) {
            var dataSource = parent.ExplorerFilterDefinitionDataSource();
            self.Caption(dataSource.Caption);
            self.ObjectValue(dataSource.ObjectValue);
            self.ExplorerFilterOperatorId(dataSource.ExplorerFilterOperatorId);
        }
        self.Focus();
        self.ObjectValue.subscribe(function () {
            self.Save();
        });
        self.ExplorerFilterOperatorId.subscribe(function (newValue) {
            if ("13186f4d-9281-486d-85e7-c58e4ad961ff" == newValue) {
                self.ObjectValue("");
                self.TextEnabled(false);
            }
            else {
                self.TextEnabled(true);
            }
            self.Save();
        });
    };
}
export default ExplorerFilterTypeString;